/* ═══════════════════════════════════════════════════════
   VideoGamePalace – Ankaufsrechner 2 (Sammlerstücke)
   Asset: ankaufsrechner2.js
   Einbinden in theme.liquid:
   <script src="{{ 'ankaufsrechner2.js' | asset_url }}" defer></script>
═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── PREISDATEN ───────────────────────────────────────
     Format: { name, sehrGut, gut, akz, def }
     null → "auf Anfrage" / Stufe nicht verfügbar
  ─────────────────────────────────────────────────────── */
  const CATALOG = {
    konsolen: [
      { name: 'Nintendo Switch (V1/V2)',        sehrGut: 50,  gut: 33,  akz: 14,  def: null },
      { name: 'Nintendo Switch OLED',           sehrGut: 100, gut: 67,  akz: 29,  def: null },
      { name: 'Nintendo Switch Lite',           sehrGut: 80,  gut: 53,  akz: 23,  def: null },
      { name: 'Nintendo Switch 2',              sehrGut: 250, gut: 165, akz: null, def: null },
      { name: 'PlayStation 5 (Disc)',           sehrGut: 250, gut: 165, akz: 72,  def: null },
      { name: 'PlayStation 5 (Digital)',        sehrGut: 200, gut: 133, akz: 58,  def: null },
      { name: 'PlayStation 5 Slim',             sehrGut: 300, gut: 198, akz: 86,  def: null },
      { name: 'PlayStation 5 Pro',              sehrGut: 500, gut: 330, akz: 144, def: null },
      { name: 'PS Portal',                      sehrGut: 100, gut: 67,  akz: 29,  def: null },
      { name: 'Xbox Series X',                  sehrGut: 250, gut: 165, akz: 72,  def: null },
      { name: 'Xbox Series S',                  sehrGut: 100, gut: 67,  akz: 29,  def: null },
    ],
    switch: [
      { name: 'Switch-Spiel (aktuell, mit Hülle)', sehrGut: 20, gut: 15, akz: 8,  def: 3 },
      { name: 'Switch-Spiel (älter)',               sehrGut: 15, gut: 10, akz: 6,  def: 2 },
      { name: 'Switch-Spiel (Rarität)',             sehrGut: null, gut: null, akz: null, def: null },
      { name: 'Joy-Con Paar (original)',            sehrGut: 25, gut: 20, akz: 18, def: 6 },
      { name: 'Switch Pro Controller',              sehrGut: 30, gut: 25, akz: 20, def: 8 },
      { name: 'Switch Dock (original)',             sehrGut: 25, gut: 18, akz: 12, def: 5 },
    ],
    playstation: [
      { name: 'PS5-Spiel (aktuell)',        sehrGut: 20, gut: 14, akz: 9,  def: 3  },
      { name: 'PS5-Spiel (älter)',          sehrGut: 12, gut: 9,  akz: 6,  def: 2  },
      { name: 'PS4-Spiel',                  sehrGut: 9, gut: 6,  akz: 4,  def: 1  },
      { name: 'PS3-Spiel',                  sehrGut: 5, gut: 4,  akz: 2,  def: 1  },
      { name: 'PS1-Spiel (Standard)',       sehrGut: 10, gut: 8,  akz: 5,  def: 2  },
      { name: 'PS1-Spiel (Rarität)',        sehrGut: null, gut: null, akz: null, def: null },
      { name: 'DualSense Controller',       sehrGut: 30, gut: 25, akz: 20, def: 10 },
      { name: 'DualShock 4 Controller',     sehrGut: 15, gut: 12, akz: 10, def: 5  },
      { name: 'PlayStation 1 Konsole',      sehrGut: 30, gut: 25, akz: 28, def: 10 },
      { name: 'PlayStation 2 Konsole',      sehrGut: 30, gut: 25, akz: 28, def: 10 },
      { name: 'PlayStation 3 Konsole',      sehrGut: 50, gut: 40, akz: 38, def: 15 },
    ],
    retro: [
      { name: 'SNES Konsole',                sehrGut: 50,   gut: 35, akz: 18, def: 7  },
      { name: 'SNES Spiel (Standard)',       sehrGut: 15, gut: 12, akz: 7,  def: 3  },
      { name: 'SNES Spiel (Rarität)',        sehrGut: null, gut: null, akz: null, def: null },
      { name: 'Nintendo 64 Konsole',         sehrGut: 50,   gut: 35, akz: 18, def: 7  },
      { name: 'N64 Spiel (Standard)',        sehrGut: 15, gut: 10, akz: 6,  def: 2  },
      { name: 'N64 Spiel (Rarität)',         sehrGut: null, gut: null, akz: null, def: null },
      { name: 'Nintendo GameCube Konsole',   sehrGut: 50,   gut: 30, akz: 20, def: 8  },
      { name: 'GameCube Spiel (Standard)',   sehrGut: 15, gut: 12, akz: 7,  def: 3  },
      { name: 'GameCube Spiel (Rarität)',    sehrGut: null, gut: null, akz: null, def: null },
      { name: 'Sega Mega Drive Konsole',     sehrGut: 45,   gut: 30, akz: 15, def: 6  },
      { name: 'Sega Saturn Konsole',         sehrGut: 50,   gut: 42, akz: 22, def: 9  },
      { name: 'Sega Saturn Spiel (Standard)',sehrGut: 15, gut: 10, akz: 8,  def: 3  },
      { name: 'Sega Dreamcast Konsole',      sehrGut: 50,   gut: 40, akz: 20, def: 8  },
      { name: 'NES Konsole',                 sehrGut: 50,   gut: 35, akz: 22, def: 12 },
      { name: 'NES Spiel',                   sehrGut: 15, gut: 10, akz: 6,  def: 2  },
    ],
    handheld: [
      { name: 'Game Boy (original)',           sehrGut: 50,  gut: 35, akz: 18, def: 7  },
      { name: 'Game Boy Color',                sehrGut: 55,  gut: 38, akz: 20, def: 8  },
      { name: 'Game Boy Advance',              sehrGut: 40,  gut: 35, akz: 24, def: 9  },
      { name: 'Game Boy Advance SP (AGS-001)', sehrGut: 50,  gut: 45, akz: 22, def: 9  },
      { name: 'Game Boy Advance SP (AGS-101)', sehrGut: 50,  gut: 45, akz: 24, def: 10 },
      { name: 'Game Boy Spiel (Standard)',     sehrGut: 10, gut: 8,  akz: 5,  def: 2  },
      { name: 'Nintendo DS / DS Lite',         sehrGut: 30,  gut: 25, akz: 20, def: 10 },
      { name: 'Nintendo DSi',                  sehrGut: 30,  gut: 25, akz: 20, def: 8  },
      { name: 'Nintendo 3DS',                  sehrGut: 50,  gut: 40, akz: 25, def: 10 },
      { name: 'Nintendo 3DS XL',               sehrGut: 100, gut: 75, akz: 36, def: 14 },
      { name: 'Nintendo 2DS',                  sehrGut: 50,  gut: 35, akz: 18, def: 7  },
      { name: 'DS / 3DS Spiel (Standard)',     sehrGut: 10, gut: 8,  akz: 5,  def: 2  },
      { name: 'PSP',                           sehrGut: 55, gut: 50, akz: 40, def: 18 },
      { name: 'PS Vita',                       sehrGut: 60,  gut: 52, akz: 30, def: 12 },
    ],
    tonie: [
      { name: 'Tonie-Figur (Standard, aktuell)', sehrGut: 5,  gut: 4,  akz: 2,  def: null },
      { name: 'Tonie-Figur (eingestellt)',        sehrGut: 14, gut: 10, akz: 5,  def: null },
      { name: 'Tonie-Rarität',                    sehrGut: null, gut: null, akz: null, def: null },
      { name: 'Toniebox (funktionsfähig)',        sehrGut: 25, gut: 18, akz: 10, def: null },
      { name: 'Kreativ-Tonie (leer)',             sehrGut: 4,  gut: 3,  akz: 2,  def: null },
    ],
  };

  /* Anzeigenamen + Reihenfolge der Zustands-Buttons */
  const COND_LABELS = { sehrGut: 'Sehr gut', gut: 'Gut', akz: 'Akzeptabel', def: 'Defekt' };
  const COND_ORDER  = ['sehrGut', 'gut', 'akz', 'def'];

  /* ── CART STATE ─────────────────────────────────────── */
  let cart = [];
  let itemCounter = 0;

  /* ── INIT ───────────────────────────────────────────── */
  function init() {
    // Guard: only run on pages that have the calculator
    if (!document.getElementById('catTabs')) return;

    buildAllGroups();
    bindTabs();
    bindCart();
    bindCustom();
    bindFaq();
  }

  /* ── BUILD ITEM GROUPS ──────────────────────────────── */
  function buildAllGroups() {
    Object.entries(CATALOG).forEach(([cat, items]) => {
      const grp = document.getElementById('grp-' + cat);
      if (!grp) return;
      grp.innerHTML = items.map((item, idx) => buildRow(cat, idx, item)).join('');
      // Bind condition buttons
      grp.querySelectorAll('.cond-btn').forEach(btn => {
        btn.addEventListener('click', onCondClick);
      });
      grp.querySelectorAll('.item-add').forEach(btn => {
        btn.addEventListener('click', onAddClick);
      });
    });
  }

  /* Liefert die erste verfügbare (nicht-null) Zustandsstufe eines Artikels */
  function firstAvailableCond(item) {
    return COND_ORDER.find(c => item[c] !== null) || 'gut';
  }

  function buildRow(cat, idx, item) {
    const id = cat + '_' + idx;
    const defaultCond = firstAvailableCond(item);
    const defaultPrice = item[defaultCond] !== null ? fmtPrice(item[defaultCond]) : 'Anfrage';

    const buttons = COND_ORDER
      .filter(cond => item[cond] !== undefined) // nur Stufen zeigen, die im Datensatz existieren
      .map(cond => {
        const selClass = cond === defaultCond ? ' sel' : '';
        const disabled = item[cond] === null ? ' disabled' : '';
        return `<button class="cond-btn${selClass}${disabled}" data-cond="${cond}" data-id="${id}">${COND_LABELS[cond]}</button>`;
      }).join('');

    return `
      <div class="item-row" data-id="${id}" data-cat="${cat}" data-idx="${idx}">
        <span class="item-name">${item.name}</span>
        <div class="item-cond">
          ${buttons}
        </div>
        <span class="item-price" id="price-${id}">${defaultPrice}</span>
        <button class="item-add" data-id="${id}" aria-label="${item.name} hinzufügen">+</button>
      </div>`;
  }

  function onCondClick(e) {
    const btn = e.currentTarget;
    if (btn.classList.contains('disabled')) return;
    const id = btn.dataset.id;
    const cond = btn.dataset.cond;
    // Toggle sel within this row
    const row = btn.closest('.item-row');
    row.querySelectorAll('.cond-btn').forEach(b => b.classList.remove('sel'));
    btn.classList.add('sel');
    // Update displayed price
    const [cat, idx] = id.split('_');
    const item = CATALOG[cat][+idx];
    const val = item[cond];
    document.getElementById('price-' + id).textContent = val !== null ? fmtPrice(val) : 'Anfrage';
  }

  function onAddClick(e) {
    const btn = e.currentTarget;
    const id = btn.dataset.id;
    const [cat, idx] = id.split('_');
    const item = CATALOG[cat][+idx];
    const row = btn.closest('.item-row');
    const condBtn = row.querySelector('.cond-btn.sel') || row.querySelector('.cond-btn:not(.disabled)');
    const cond = condBtn ? condBtn.dataset.cond : firstAvailableCond(item);
    const condLabel = COND_LABELS[cond] || 'Gut';
    const price = item[cond];

    addToCart({
      name: item.name + ' (' + condLabel + ')',
      price: price,
      custom: false,
    });

    // Visual feedback
    btn.classList.add('added');
    btn.textContent = '✓';
    setTimeout(() => {
      btn.classList.remove('added');
      btn.textContent = '+';
    }, 1200);
  }

  /* ── CUSTOM ITEM ────────────────────────────────────── */
  function bindCustom() {
    const addBtn = document.getElementById('addCustomBtn');
    if (!addBtn) return;
    addBtn.addEventListener('click', () => {
      const nameEl = document.getElementById('customName');
      const condEl = document.getElementById('customCond');
      const name = nameEl ? nameEl.value.trim() : '';
      if (!name) { nameEl && nameEl.focus(); return; }
      const condLabel = COND_LABELS[condEl.value] || 'Gut';
      addToCart({ name: name + ' (' + condLabel + ')', price: null, custom: true });
      nameEl.value = '';
    });
  }

  /* ── CART ───────────────────────────────────────────── */
  function addToCart(entry) {
    entry.uid = ++itemCounter;
    cart.push(entry);
    renderCart();
  }

  function removeFromCart(uid) {
    cart = cart.filter(e => e.uid !== uid);
    renderCart();
  }

  function renderCart() {
    const itemsEl   = document.getElementById('cartItems');
    const emptyEl   = document.getElementById('cartEmpty');
    const divider   = document.getElementById('cartDivider');
    const totalRow  = document.getElementById('cartTotalRow');
    const totalEl   = document.getElementById('cartTotal');
    const rangeEl   = document.getElementById('cartRange');
    const actionsEl = document.getElementById('cartActions');

    if (!itemsEl) return;

    if (cart.length === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) { emptyEl.style.display = ''; itemsEl.appendChild(emptyEl); }
      if (divider)   divider.style.display   = 'none';
      if (totalRow)  totalRow.style.display  = 'none';
      if (actionsEl) actionsEl.style.display = 'none';
      return;
    }

    // Remove empty message
    if (emptyEl) emptyEl.style.display = 'none';

    itemsEl.innerHTML = cart.map(e => `
      <div class="cart-item">
        <span class="cart-item-name">${e.name}</span>
        <span class="cart-item-price">${e.price !== null ? fmtPrice(e.price) : 'Anfrage'}</span>
        <button class="cart-item-remove" data-uid="${e.uid}" aria-label="Entfernen">×</button>
      </div>`).join('');

    itemsEl.querySelectorAll('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', () => removeFromCart(+btn.dataset.uid));
    });

    // Totals
    const priced = cart.filter(e => e.price !== null);
    const total  = priced.reduce((s, e) => s + e.price, 0);
    const low    = Math.round(total * 0.85);
    const high   = Math.round(total * 1.1);
    const hasCustom = cart.some(e => e.custom || e.price === null);

    if (divider)  divider.style.display  = '';
    if (totalRow) totalRow.style.display = '';
    if (totalEl)  totalEl.textContent    = fmtPrice(total) + (hasCustom ? ' +' : '');
    if (rangeEl)  rangeEl.textContent    = priced.length > 0
      ? 'Richtwert: ' + fmtPrice(low) + ' – ' + fmtPrice(high) + (hasCustom ? ' + individuelle Artikel' : '')
      : '';
    if (actionsEl) actionsEl.style.display = '';
  }

  function bindCart() {
    const btnAnfragen = document.getElementById('btnAnfragen');
    const btnReset    = document.getElementById('btnReset');

    if (btnAnfragen) {
      btnAnfragen.addEventListener('click', () => {
        const formBody = document.getElementById('formBody');
        if (!formBody) {
          document.querySelector('#kontakt')?.scrollIntoView({ behavior: 'smooth' });
          return;
        }
        const lines = cart.map(e =>
          e.price !== null
            ? `${e.name}: ${fmtPrice(e.price)}`
            : `${e.name}: auf Anfrage`
        );
        const priced = cart.filter(e => e.price !== null);
        const total  = priced.reduce((s, e) => s + e.price, 0);
        if (total > 0) lines.push('', 'Geschätzter Gesamtwert: ' + fmtPrice(total));
        formBody.value = lines.join('\n');
        document.querySelector('#kontakt')?.scrollIntoView({ behavior: 'smooth' });
      });
    }

    if (btnReset) {
      btnReset.addEventListener('click', () => {
        cart = [];
        renderCart();
      });
    }
  }

  /* ── TABS ───────────────────────────────────────────── */
  function bindTabs() {
    const tabs = document.getElementById('catTabs');
    if (!tabs) return;
    tabs.addEventListener('click', e => {
      const tab = e.target.closest('.cat-tab');
      if (!tab) return;
      const cat = tab.dataset.cat;
      // Tabs
      tabs.querySelectorAll('.cat-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      // Groups
      document.querySelectorAll('.item-group').forEach(g => g.classList.remove('active'));
      const grp = document.getElementById('grp-' + cat);
      if (grp) grp.classList.add('active');
    });
  }

  /* ── FAQ ────────────────────────────────────────────── */
  function bindFaq() {
    document.querySelectorAll('.faq-q').forEach(q => {
      q.addEventListener('click', () => {
        const item = q.closest('.faq-item');
        if (!item) return;
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── HELPERS ────────────────────────────────────────── */
  function fmtPrice(val) {
    return '€\u00A0' + val;
  }

  /* ── BOOT ───────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
